import { SimpleTitleOwnership } from "react-migration/domains/ownership";
import { useTranslation } from "react-migration/lib";

const AdditionalOwners = ({ additionalOwners }: { additionalOwners: SimpleTitleOwnership[] }) => {
  const { t } = useTranslation();
  return !additionalOwners.length ? null : (
    <div className="atlas-pt-4">
      <span className="atlas-text-content-primary atlas-font-semibold">
        {t("sites.card.ownership.additional_owners", {
          count: additionalOwners.length,
        })}
      </span>
      {additionalOwners.map((owner) => (
        <div className="atlas-flex atlas-flex-col" key={String(owner.name) + String(owner.address)}>
          <span className="atlas-text-content-primary atlas-font-semibold">{owner?.name}</span>
          <span className="atlas-text-neutral-800 atlas-py-0.5">{owner?.address ?? ""}</span>
        </div>
      ))}
    </div>
  );
};

const MainOwner = ({ owner }: { owner?: SimpleTitleOwnership }) => {
  return !owner ? null : (
    <>
      <span className="atlas-flex atlas-text-content-primary atlas-font-semibold atlas-text-sm">
        {owner?.name}
      </span>
      <span className="atlas-flex atlas-text-neutral-800 atlas-py-0.5">{owner?.address ?? ""}</span>
    </>
  );
};

export const TitleOwners = ({ titleOwners }: { titleOwners: SimpleTitleOwnership[] }) => {
  const { t } = useTranslation();

  const availableOwners = titleOwners.some((owner) => owner?.name !== "ATTRIBUTE_UNAVAILABLE");
  const mainOwner = titleOwners[0];

  return (
    <div
      className="atlas-flex atlas-flex-col atlas-border-b atlas-border-border-divider atlas-mb-4"
      data-testid="ownership-overview-title-owner"
    >
      <span className="atlas-font-semibold atlas-text-xl atlas-text-content-primary">
        {t("sites.card.ownership.title_owner", {
          count: titleOwners.length,
        })}
      </span>

      {availableOwners ? (
        <div className="atlas-py-4">
          <MainOwner owner={mainOwner} />
          <AdditionalOwners additionalOwners={titleOwners.slice(1)} />
        </div>
      ) : (
        <span className="atlas-py-4 atlas-text-content-primary atlas-font-semibold atlas-text-base">
          {t("sites.card.ownership.owner_info_not_found")}
        </span>
      )}
    </div>
  );
};
